import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { esMensajeDeMiEmpresa } from '../../../helpers/esMensajeDeMiEmpresa'
import { formatearFecha } from '../../helpers/helper'
import { Adjuntos } from '../../pages/preguntas/Adjuntos'
import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import { adjuntoBuilder } from '../upload/adjuntoBuilder'
import styles from './MensajeriaNew.module.css'

const parsearIds = (ids) =>
  String(ids ?? '')
    .split(',')
    .map((id) => parseInt(id.trim()))
    .filter(Boolean)

const revocarUrls = (lista) => lista.forEach(({ url }) => url && URL.revokeObjectURL(url))

const cargarAdjuntos = async (ids) => {
  if (ids.length === 0) {
    return []
  }

  const resultados = await Promise.all(
    ids.map(async (id) => {
      try {
        const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(id)
        const { dataAdjunto, adjunto } = data
        const preview = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
          preview: true
        })
        return { ...preview, idAdjunto: adjunto.idAdjunto || id }
      } catch {
        return null
      }
    })
  )

  return resultados.filter(Boolean)
}

export const Mensaje = ({ mensaje, usuario, empid, tipoMensajes }) => {
  const {
    idMensaje,
    texto,
    fechaEscrito,
    textoRta,
    fechaEscritoRta,
    idAdjunto,
    idsAdjuntos,
    idsAdjuntosRta
  } = mensaje
  const [adjuntos, setAdjuntos] = useState([])
  const [adjuntosRta, setAdjuntosRta] = useState([])

  const clavePregunta = parsearIds(idsAdjuntos || idAdjunto).join(',')
  const claveRespuesta = parsearIds(idsAdjuntosRta).join(',')

  useEffect(() => {
    let activo = true
    let adjuntosCreados = []
    const ids = parsearIds(clavePregunta)

    cargarAdjuntos(ids).then((cargados) => {
      if (!activo) {
        revocarUrls(cargados)
        return
      }
      adjuntosCreados = cargados
      setAdjuntos(cargados)
    })

    return () => {
      activo = false
      revocarUrls(adjuntosCreados)
    }
  }, [clavePregunta])

  useEffect(() => {
    let activo = true
    let adjuntosCreados = []
    const ids = parsearIds(claveRespuesta)

    cargarAdjuntos(ids).then((cargados) => {
      if (!activo) {
        revocarUrls(cargados)
        return
      }
      adjuntosCreados = cargados
      setAdjuntosRta(cargados)
    })

    return () => {
      activo = false
      revocarUrls(adjuntosCreados)
    }
  }, [claveRespuesta])

  const obtenerClaseAlineado = () =>
    tipoMensajes === 'chat' && esMensajeDeMiEmpresa(mensaje, usuario, empid)
      ? styles.mensajeMio
      : styles.mensaje

  const renderAdjuntos = (lista) =>
    lista.length > 0 && (
      <span className={styles.archivoWrapper}>
        <Adjuntos adjunto={lista} />
      </span>
    )

  const adjuntosRender = renderAdjuntos(adjuntos)

  if (tipoMensajes === 'preguntas') {
    return (
      <div>
        <div className={styles.preguntaBox}>
          <div className={styles.preguntaHeader}>
            <span className={styles.preguntaIcon}>
              <i className="fa fa-question" />
            </span>
            <span className={styles.preguntaLabel}>Pregunta</span>
            <span className={styles.fechaMensaje}>{formatearFecha(fechaEscrito, 'FH', 'hs')}</span>
          </div>
          <p className={styles.textoQA}>{texto}</p>
          {adjuntosRender}
        </div>
        {textoRta ? (
          <div className={styles.respuestaBox}>
            <div className={styles.respuestaHeader}>
              <i className={`fa fa-reply ${styles.respuestaIcon}`} />
              <span className={styles.respuestaLabel}>Respuesta del vendedor</span>
              <span className={styles.fechaMensaje}>
                {formatearFecha(fechaEscritoRta, 'FH', 'hs')}
              </span>
            </div>
            <p className={styles.textoQA}>{textoRta}</p>
            {renderAdjuntos(adjuntosRta)}
          </div>
        ) : (
          <p className={styles.sinRespuesta}>Sin respuesta aún</p>
        )}
        <hr />
      </div>
    )
  }

  return (
    <div key={idMensaje}>
      <div className={obtenerClaseAlineado()}>
        <p>{texto}</p>
        {adjuntosRender}
        <span className={styles.fechaMensaje}>{formatearFecha(fechaEscrito, 'FH', 'hs')}</span>
      </div>

      {textoRta && (
        <div className={`${styles.contenedorRespuesta} text-secondary position-relative`}>
          <div className={styles.respuestaFlecha}></div>
          <p className={styles.textoMensaje}>
            {textoRta}
            <span className={styles.fechaMensaje}>
              {formatearFecha(fechaEscritoRta, 'FH', 'hs')}
            </span>
          </p>
          {renderAdjuntos(adjuntosRta)}
        </div>
      )}
    </div>
  )
}

Mensaje.propTypes = {
  mensaje: PropTypes.shape({
    idMensaje: PropTypes.number.isRequired,
    texto: PropTypes.string.isRequired,
    fechaEscrito: PropTypes.string.isRequired,
    textoRta: PropTypes.string,
    fechaEscritoRta: PropTypes.string,
    idUsuarioEmisor: PropTypes.number,
    idUsuarioChat: PropTypes.number,
    idAdjunto: PropTypes.number,
    idsAdjuntos: PropTypes.string,
    idsAdjuntosRta: PropTypes.string,
    idVendedor: PropTypes.number.isRequired,
    idComprador: PropTypes.number,
    empidVendedor: PropTypes.string,
    empidComprador: PropTypes.string,
    comprador: PropTypes.string.isRequired,
    vendedor: PropTypes.string.isRequired
  }).isRequired,
  usuario: PropTypes.number.isRequired,
  empid: PropTypes.string,
  tipoMensajes: PropTypes.string.isRequired
}
